<template>
	<div class="command-bar-display">
		<div class="text-cursor-indicator"></div>
		<div class="command-wrapper">
			<v-icon class="pr-1"> mdi-bank-outline </v-icon>
			<span>{{ command }}</span>
		</div>
		<CommandBarDispalySvg />
	</div>
</template>

<script>
import CommandBarDispalySvg from './assets/CommandBarDispalySvg';

export default {
	name: 'CommandBarDisplay',
	components: {
		CommandBarDispalySvg,
	},
	props: {
		command: { type: String },
	},
};
</script>

<style scoped lang="scss">
@keyframes cursor-blink {
	0% {
		opacity: 0;
	}
}

.command-bar-display {
	position: relative;

	.command-wrapper {
		position: absolute;
		top: 164px;
		left: 82px;
		z-index: 1;
	}

	.text-cursor-indicator {
		position: absolute;
		top: 114px;
		left: 65px;
		z-index: 1;

		&::after {
			content: '';
			width: 1px;
			height: 18px;
			margin-left: 2px;
			border-left: 1px solid black;
			animation: cursor-blink 1.5s steps(2) infinite;
		}
	}
}
</style>
